// ERP-wide shared styles and constants
export const erpColors = {
  primary: '#2563eb',
  primaryHover: '#1d4ed8',
  success: '#059669',
  warning: '#d97706',
  danger: '#dc2626',
  info: '#0891b2',
  
  // Section colors
  classification: { bg: 'bg-blue-50', border: 'border-blue-200', header: 'bg-blue-600' },
  identification: { bg: 'bg-emerald-50', border: 'border-emerald-200', header: 'bg-emerald-600' },
  pricing: { bg: 'bg-amber-50', border: 'border-amber-200', header: 'bg-amber-600' },
  inventory: { bg: 'bg-purple-50', border: 'border-purple-200', header: 'bg-purple-600' },
  tax: { bg: 'bg-rose-50', border: 'border-rose-200', header: 'bg-rose-600' },
  summary: { bg: 'bg-slate-50', border: 'border-slate-200', header: 'bg-slate-700' },
};

export const erpDarkColors = {
  primary: '#3b82f6',
  primaryHover: '#60a5fa',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#06b6d4',
  
  classification: { bg: 'bg-blue-950/30', border: 'border-blue-800', header: 'bg-blue-700' },
  identification: { bg: 'bg-emerald-950/30', border: 'border-emerald-800', header: 'bg-emerald-700' },
  pricing: { bg: 'bg-amber-950/30', border: 'border-amber-800', header: 'bg-amber-700' },
  inventory: { bg: 'bg-purple-950/30', border: 'border-purple-800', header: 'bg-purple-700' },
  tax: { bg: 'bg-rose-950/30', border: 'border-rose-800', header: 'bg-rose-700' },
  summary: { bg: 'bg-slate-800/50', border: 'border-slate-600', header: 'bg-slate-600' },
};

// Field styling
export const fieldStyles = {
  base: 'w-full px-3 py-2 text-sm rounded-lg border transition-all focus:outline-none focus:ring-2 focus:ring-blue-500/40',
  light: 'bg-white border-slate-300 text-slate-900 placeholder:text-slate-400',
  dark: 'bg-slate-800 border-slate-600 text-white placeholder:text-slate-500',
  required: 'border-amber-400',
  error: 'border-red-500 bg-red-50',
  disabled: 'bg-slate-100 cursor-not-allowed opacity-60',
};

// Card section styling
export const sectionStyles = {
  card: 'rounded-xl border shadow-sm overflow-hidden',
  header: 'px-4 py-2.5 text-xs font-bold uppercase tracking-wider text-white flex items-center justify-between',
  content: 'p-4',
};

// Grid layouts
export const gridLayouts = {
  form2: 'grid grid-cols-1 md:grid-cols-2 gap-4',
  form3: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
  form4: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4',
  form6: 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3',
};

// Keyboard shortcuts
export const keyboardShortcuts = [
  { key: 'F1', action: 'Save', description: 'Save current record' },
  { key: 'F2', action: 'Save & Close', description: 'Save and close form' },
  { key: 'F3', action: 'Clear', description: 'Clear all fields' },
  { key: 'F4', action: 'Close', description: 'Close without saving' },
  { key: 'F5', action: 'Refresh', description: 'Refresh data' },
  { key: 'F6', action: 'Focus Grid', description: 'Focus on item grid' },
  { key: 'Ctrl+N', action: 'New', description: 'Create new record' },
  { key: 'Ctrl+S', action: 'Save', description: 'Quick save' },
  { key: 'Tab', action: 'Next Field', description: 'Move to next field' },
  { key: 'Shift+Tab', action: 'Previous Field', description: 'Move to previous field' },
];
